import { CommonService } from './../../../../../core/src/lib/services/common.service';
import { ProjectService } from './../../../../../../apps/resource-portal/src/app/services/project.service';
import { Component, Input, OnChanges, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil, Subject } from 'rxjs';
import { Location } from '@angular/common';

@Component({
  selector: 'concourse-title-bar',
  templateUrl: './title-bar.component.html',
  styleUrls: ['./title-bar.component.scss']
})
export class TitleBarComponent implements OnInit, OnDestroy, OnChanges {
  projectId = null;
  public project = null;
  $unsubscribe = new Subject<void>();
  @Input('title') title: string = "";
  @Input('primarySubtitle') primarySubtitle: string = "";
  @Input('secondarySubtitle') secondarySubtitle: string = "";
  @Input('backNavigation') backNavigation: boolean = false;
  @Input('flat') flat: boolean = false;
  @Output('projectDetails') projectDetails = new EventEmitter<any>();
  selectedProject = null;
  projects = [];

  constructor(
    private activateRoute: ActivatedRoute,
    private _projectService: ProjectService,
    private location: Location,
    private _commonService: CommonService
  ) { }

  ngOnInit(): void {
  }

  assignProject(val) {
    this._commonService.selectedProject.next(val);
  }

  ngOnChanges() {
    this.activateRoute.queryParams.subscribe((result) => {
      if (result && result['projectId']) {
        this.projectId = result['projectId'] || null;
        this.project = this.location.getState();
        // if (this.project && this.project?.projectname) {
        //   //got the project from router state
        //   this.secondarySubtitle = this.project?.projectname;
        //   this.projectDetails.emit(this.project);
        // } 
        // else {
        //   this.getProjectDetails(result['projectId']);
        // }
        this.getProjectDetails(result['projectId']);
      } else {
        // this.router.navigate(['/projects']);
      }
    });
  }

  getProjectDetails(projectId: string) {
    if (projectId == null) {
      this.goBack();
    }
    
    this._projectService.getProjectDetails(projectId).pipe(
      takeUntil(this.$unsubscribe),
    ).subscribe((result) => {
      if (result) {
        this.project = result || [];
        this.secondarySubtitle = this.project?.projectname;
        this.projectDetails.emit(this.project);
      }
    });
  }

  goBack() {
    this.location.back();
  }

  ngOnDestroy() {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }

}
